<template>
    <div>
        <div class="globalHeader w-100">
            <header class="text-right d-flex align-items-center justify-content-between" v-if="parseInt(get_user.step) == -1">
                <div class="d-flex">
                    <div class="Steplogo ">
                        <router-link to="/dashboard" class="green">
                            <img class="d-none d-xl-block" src="/static/fxView/images/logo-black.svg" alt="fxView">
                            <img class="d-xl-none" src="/static/fxView/images/fxview_logo_white.svg" alt="fxView">
                        </router-link>
                    </div>
                </div>
                <div class="backSection">
                    <router-link to="/dashboard" class="back"><feather type="home" ></feather> </router-link>
                    <!-- <router-link to="/step1" class="back" v-if="$route.name == 'fxView.step_four' && parseInt(get_user.step) != 3" ><feather type="chevron-left"></feather> </router-link>
                    <router-link to="/step2" class="back" v-else-if="$route.name == 'fxView.step_five' && parseInt(get_user.step) != 3" ><feather type="chevron-left" ></feather> </router-link> -->
                </div>
            </header>
            <div class="dashSection">
                <router-link class="prism_btn homebtn stepsBtn d-flex align-items-center justify-content-center d-lg-none px-3 pr-0" to="/dashboard"><feather class="mr-0" type="home" ></feather></router-link>
                <router-link class="prism_btn stepsBtn d-none d-lg-inline-flex" to="/dashboard">Go to Dashboard</router-link>
                <!-- <router-link to="/dashboard" class="back"><feather type="home" ></feather> </router-link> -->
                <!-- <router-link to="/step1" class="back" v-if="$route.name == 'fxView.step_four' && parseInt(get_user.step) != 3" ><feather type="chevron-left"></feather> </router-link>
                <router-link to="/step2" class="back" v-else-if="$route.name == 'fxView.step_five' && parseInt(get_user.step) != 3" ><feather type="chevron-left" ></feather> </router-link> -->
            </div>
        </div>
        <!-- <div class="d-flex justify-content-center align-items-center stepListing w-100" v-if="parseInt(get_user.step) != 4">
            <ul class="d-flex justify-content-between" style="overflow-x: auto;">
                <li class="nav-item d-flex align-items-center text-nowrap ">  
                    <router-link :style="{pointerEvents: 'none'}" to="/step1"  :class="($route.name == 'fxView.step_one')?'active':''">
                        <figure><img src="../../../../static/fxView/images/personal-information.svg" alt="fxView"></figure>
                        <h4>{{$t('steps_heading1')}}</h4>
                    </router-link>
                    <span><feather type="chevron-right" ></feather></span>
                </li>
                <li  class="nav-item d-flex align-items-center text-nowrap"> 
                    <router-link :style="{pointerEvents: 'none'}" to="/step2" :class="($route.name == 'fxView.step_two')?'active':''">
                        <figure><img src="../../../../static/fxView/images/declaration.svg" alt="fxView"></figure>
                        <h4>{{$t('step2_financialDetails')}}</h4>
                    </router-link >
                   <span><feather type="chevron-right" ></feather></span>
                </li>
                <li  class="nav-item d-flex align-items-center text-nowrap">
                    <router-link :style="{pointerEvents: 'none'}" to="/step3" :class="($route.name == 'fxView.step_three')?'active':''">
                        <figure><img src="../../../../static/fxView/images/declaration.svg" alt="fxView"></figure>
                        <h4>{{ $t('step3_Questions') }}</h4>
                    </router-link >
                   <span><feather type="chevron-right" ></feather></span>
                </li>
                <li  class="nav-item d-flex align-items-center text-nowrap"> 
                    <router-link :style="{pointerEvents: 'none'}" to="/step4" :class="($route.name == 'fxView.step_four')?'active':''">
                        <figure><img src="../../../../static/fxView/images/declaration.svg" alt="fxView"></figure>
                        <h4>{{$t('steps_heading2')}}</h4>
                    </router-link >
                   <span><feather type="chevron-right" ></feather></span>
                </li>
                <li class="nav-item last d-flex align-items-center text-nowrap" >                       
                    <router-link :style="{pointerEvents: 'none'}" class="mr-0" to="/step5" :class="($route.name == 'fxView.step_five')?'active':''">
                        <figure><img src="../../../../static/fxView/images/cloud-computing.svg" alt="fxView"></figure>
                        <h4>{{$t('steps_heading3')}}</h4>
                    </router-link> 
                </li>
            </ul>
        </div> -->
        <div
            v-if="$route.path !== '/step4'"
            class="registerSteps d-flex flex-column flex-lg-row align-items-center justify-content-start justify-content-lg-center position-relative">
            <img class="img-fuid left dotsBg" src="../../../../static/fxView/images/registerflow-new/leftshape.png">
            <img class="img-fuid right dotsBg" src="../../../../static/fxView/images/registerflow-new/rightshape.png">
            <div class="mobView w-100">
                <img class="img-fuid logo mx-auto d-block logoImg"
                    src="../../../../static/fxView/images/registerflow-new/logo.svg">
                <ul class="mobSteps d-flex align-items-center justify-content-center">
                    <li :class="($route.name == 'fxView.step_one')?'active': (get_user.step >= 1)?'done':''">Step 1</li>
                    <li :class="($route.name == 'fxView.step_two')?'active': (get_user.step >= 2)?'done':''">Step 2</li>
                    <li :class="($route.name == 'fxView.step_three')?'active': (account_detail.demo_live == 1 || get_user.step >= 4)?'done':''">Step 3</li>
                    <li class="stepItem" :class="($route.name == 'fxView.step_four')?'active': (get_user.step > 5)?'done':''">Step 4</li>
                </ul>
            </div>
            <div class="mainBox">
                <div class="stepsCol">
                    <img class="img-fluid mb-5" src="../../../../static/fxView/images/registerflow-new/white-logo.svg"
                        alt="">
                    <h4 class="f-20 mb-2 text-white medium">Step 
                        <!-- {{ 
                            (this.get_user.step == 0) 
                            ? (this.get_user.step + 1) 
                            : (this.get_user.step < 4)
                            ? (this.get_user.step + 1)
                            : (this.get_user.step == 4) 
                            ? 5 : 'hello'
                        }}  -->
                        <!-- {{ this.get_user.step }} == -->
                        {{ getStepValue(this.get_user.step) }} 
                    of 4</h4>
                    <p class="text-white">A quick verification about your
                        financial status . It's all about
                        keeping your environment safe
                        and secure.</p>
                    <div class="stepsRow">
                        <div class="stepItem" :class="($route.name == 'fxView.step_one')?'active': (get_user.step >= 1)?'done':''" >
                            <h4>Personal Information</h4>
                        </div>
                        <div class="stepItem" :class="($route.name == 'fxView.step_two')?'active': (get_user.step >= 2)?'done':''" >
                            <h4>Financial Details</h4>
                        </div>
                        <div class="stepItem" :class="($route.name == 'fxView.step_three')?'active': (account_detail.demo_live == 1 || get_user.step >= 4)?'done':''" >
                            <h4>Create Live Account</h4>
                        </div>
                        <div class="stepItem" :class="($route.name == 'fxView.step_four')?'active': (get_user.step > 5)?'done':''" >
                            <h4>Start Trading</h4>
                        </div>
                    </div>
                </div>
                <div class="stepsContent">
                    <stepOne v-if="($route.name == 'fxView.step_one')"></stepOne>
                    <stepTwo v-if="($route.name == 'fxView.step_two')"></stepTwo>
                    <stepThree v-if="($route.name == 'fxView.step_three')"></stepThree>
                    <stepFive v-if="($route.name == 'fxView.step_five')"></stepFive> 
                    <createLiveAccount  v-if="($route.name == 'fxView.createliveAccount')"></createLiveAccount>
                    <!-- <financialDetails></financialDetails> -->
                    <!-- <uploadDocuments></uploadDocuments> -->
                </div>
               
            </div>
        </div>
        <div>
            <stepFour v-if="($route.name == 'fxView.step_four')"></stepFour> 
        </div>
        <!-- <router-view /> -->
    </div>
</template>
<script>
import stepOne from './step1'
import stepTwo from './step2'
import stepThree from './step3'
import stepFour from './step4'
import stepFive from './step5'
import createLiveAccount from './create_live_account'
// import financialDetails from './financial-details'
// import uploadDocuments from './upload-documents'


export default {
    data() {
        return {
            pathName: '/step1'
        }
    },
    components: {
        stepOne: stepOne,
        stepTwo: stepTwo,
        stepThree: stepThree,
        stepFour: stepFour,
        stepFive: stepFive,
        // financialDetails: financialDetails,
        createLiveAccount: createLiveAccount,
        // uploadDocuments: uploadDocuments,
    },
    created() {
        const getAccountdetail = sessionStorage.getItem('account_detail');
		this.account_detail = JSON.parse(getAccountdetail || '{}');
    },
    methods: {
        getStepValue(stepIndex) {
            const stepList = {
                '0': 1,
                '1': 2,
                '2': 3,
                '4': 3,
            };
            // Correct way to access object property dynamically
            const value = stepList[stepIndex];
            return value; // Returning the corresponding step value
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/steps.vue